// Custom user bookmark flags
export enum BookmarkFlagsEnum {
  UserGeneratedTour = 'user_generated_tour',
  Animated = 'animated',
  Quiz = 'quiz',
  ModeQuiz = 'mode_quiz',
  ModeContent = 'mode_content',
}
